import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { FileText, ExternalLink, Download } from "lucide-react";

export default function Rta() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/rta").then((r) => {
      setItems(Array.isArray(r.data) ? r.data : []);
      setLoaded(true);
    });
  }, []);

  const fmt = (iso) =>
    iso
      ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })
      : "";

  return (
    <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
      <header className="mb-8">
        <div className="text-xs font-mono uppercase tracking-widest text-amber-800">Documents</div>
        <h1 className="mt-1 font-serif text-4xl font-semibold text-stone-900 sm:text-5xl">Your RTA</h1>
        <p className="mt-2 text-stone-600">
          Documents and notices relating to the Recognised Tenants Association for Salford Town Hall.
        </p>
      </header>

      {!loaded ? (
        <div className="text-sm text-stone-500">Loading…</div>
      ) : items.length === 0 ? (
        <div className="rounded-3xl border border-dashed border-stone-300 bg-white p-10 text-center text-stone-600">
          No documents have been uploaded yet. Please check back soon.
        </div>
      ) : (
        <div className="space-y-6" data-testid="rta-document-list">
          {items.map((d, i) => (
            <div key={d.id}>
              <div
                className="flex items-center gap-3 rounded-2xl border border-stone-200 bg-white p-4 shadow-sm transition hover:border-amber-300 hover:bg-amber-50/40"
                data-testid={`rta-document-card-${i}`}
              >
                <div className="rounded-xl bg-red-50 p-3 ring-1 ring-red-100">
                  <FileText className="h-6 w-6 text-red-700" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="truncate font-serif text-lg font-semibold text-stone-900">
                    {d.filename || "Document"}
                  </div>
                  <div className="text-xs text-stone-500">Uploaded {fmt(d.created_at)}</div>
                </div>
                <div className="flex shrink-0 items-center gap-1">
                  <a
                    href={fileUrl(d.file_id)}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`rta-document-open-${i}`}
                    className="inline-flex items-center gap-1 rounded-lg border border-stone-300 bg-white px-2.5 py-1 text-xs font-medium text-stone-800 hover:bg-stone-50"
                  >
                    <ExternalLink className="h-3.5 w-3.5" /> Open
                  </a>
                  <a
                    href={fileUrl(d.file_id)}
                    download={d.filename || "document.pdf"}
                    className="inline-flex items-center gap-1 rounded-lg border border-stone-300 bg-white px-2.5 py-1 text-xs font-medium text-stone-800 hover:bg-stone-50"
                    title="Download"
                  >
                    <Download className="h-3.5 w-3.5" />
                  </a>
                </div>
              </div>
              <iframe
                title={d.filename || "RTA document"}
                src={fileUrl(d.file_id)}
                data-testid={`rta-document-iframe-${i}`}
                className="mt-2 h-[420px] w-full rounded-2xl border border-stone-200 bg-stone-50"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
